import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import ThreadTable from '../../components/ThreadTable/ThreadTable';
import { getThreadRequestAction } from '../../store/thread/threadActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';

const Thread = ({ threadList, threadData, getThreadRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getThreadRequest({});
  }, []);

  const handleCreateThread = () => {
    navigate('/thread/create');
  };

  return (
    <div className="thread-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('threads')}</div>
        <ThreadTable threadList={threadList} threadData={threadData} />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateThread}
        title={t('createThread')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  threadData: state.threadReducer.threadData,
  threadList: state.threadReducer.threadList,
});

const mapDispatchToProps = (dispatch) => ({
  getThreadRequest: (payload) => dispatch(getThreadRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Thread);
